define( function() {
	"use strict";

	return [];
} );



//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201706121922-6a92b31330-master/~/jquery/src/var/arr.js
// module id = 113
// module chunks = 1